module.exports = __webpack_public_path__ + "static/media/9.0f79af30.jpg";